import React, { memo } from 'react'
import { Navigate, Outlet } from 'react-router-dom';
import { isUtilAdmin } from './common/authentification-functions';
import { useForceLightTheme } from '../theme/useForceLightTheme';
import { ApplicationRoutes } from '../routes';

type Props = {}

const UtilityAdminGuard: React.FC<Props> = memo((props: Props) => {
    // Utility-admin portal is light-only (no theme toggle); pin light regardless of
    // the OS / customer-portal preference.
    useForceLightTheme();

    if(!isUtilAdmin()){
           return <Navigate to={`/${ApplicationRoutes.ADMIN_UTIL_BASE}`} replace/>
       }

    return (
        <Outlet />
    )
})

export default UtilityAdminGuard